export interface SprintUserIssue {
  id: number;
  subject: string;
  account: string | null;
  estimatedHours: number;
  spentHours: number;
  isSpillover: boolean;
  numberOfSpillover: number;
  status: string;
}

export function SprintUserIssueFromJSON(
  json: Record<string, any>,
): SprintUserIssue {
  return {
    id: json["id"],
    subject: json["subject"],
    account: json["account"] ?? null,
    estimatedHours: json["estimatedHours"],
    spentHours: json["spentHours"],
    isSpillover: json["isSpillover"],
    numberOfSpillover: json["numberOfSpillover"],
    status: json["status"],
  };
}

export interface SprintUserIssues {
  inReviewIssues: SprintUserIssue[];
  spilloverIssues: SprintUserIssue[];
  issues: SprintUserIssue[];
  reviewer: SprintUserIssue[];
  doneIssues: SprintUserIssue[];
  doneReviewer: SprintUserIssue[];
}

export function SprintUserIssuesFromJSON(
  json: Record<string, any>,
): SprintUserIssues {
  return {
    inReviewIssues: (json.inReviewIssues ?? []).map(SprintUserIssueFromJSON),
    spilloverIssues: (json.spilloverIssues ?? []).map(SprintUserIssueFromJSON),
    issues: (json.issues ?? []).map(SprintUserIssueFromJSON),
    reviewer: (json.reviewer ?? []).map(SprintUserIssueFromJSON),
    doneIssues: (json.doneIssues ?? []).map(SprintUserIssueFromJSON),
    doneReviewer: (json.doneReviewer ?? []).map(SprintUserIssueFromJSON),
  };
}
